export default "__VITE_PUBLIC_ASSET__4217d385__"